import { useState, useEffect, useCallback } from 'react';
import { THEMES, DEFAULT_THEME, THEME_STORAGE_KEY } from '../utils/themes';
import { saveUserSettings } from '../state/cloud/userSettings';

export function applyTheme(themeId) {
  const theme = THEMES[themeId] || THEMES[DEFAULT_THEME];
  const root = document.documentElement;
  root.setAttribute('data-theme', themeId);
  Object.entries(theme.vars).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
  // Override SSR-baked inline background colors
  root.style.backgroundColor = theme.vars['--app-bg'];
  document.body.style.backgroundColor = theme.vars['--app-bg'];
}

export function useTheme() {
  const [themeId, setThemeId] = useState(DEFAULT_THEME);

  useEffect(() => {
    const stored = localStorage.getItem(THEME_STORAGE_KEY) || DEFAULT_THEME;
    setThemeId(stored);
    applyTheme(stored);
  }, []);

  const setTheme = useCallback((id) => {
    if (!THEMES[id]) return;
    localStorage.setItem(THEME_STORAGE_KEY, id);
    setThemeId(id);
    applyTheme(id);
    saveUserSettings({ property: 'theme', payload: { theme: id } });
  }, []);

  return { themeId, setTheme, themes: THEMES };
}
